import React from 'react';
import { Icon } from '../';

interface TagProps {
  disabled: boolean;
  onClick: () => void;
  type?: 'eye' | 'close';
}

export const Tag: React.FC<TagProps> = ({
  disabled,
  children,
  onClick,
  type = 'eye',
}) => {
  return (
    <div
      onClick={onClick}
      className={`
        inline-flex
        flex-shrink-0
        border-1
        border-grey-10
        rounded-xl
        text-xs
        uppercase
        select-none
        dark:bg-black-real
        dark:border-grey-70
        dark:text-white
        dark:hover:border-grey-50
        dark:active:bg-black-light
        dark:active:border-black-light 
        ${
          disabled
            ? 'text-grey-50 dark:border-grey-70 dark:text-grey-70'
            : 'text-black hover:border-grey-50 hover:text-black'
        }
        font-semibold
        px-3
        h-9
        items-center
        cursor-pointer
      `}
    >
      {children}
      <Icon
        svgName={type === 'eye' ? (disabled ? 'eyeDisabled' : 'eye') : 'close'}
        className="flex text-black cursor-pointer ml-2 w-3"
        color="black"
      />
    </div>
  );
};
